import React, { useState, useEffect, useCallback } from 'react';

const NOTES = [
  'this looks bullish',
  'no idea why',
  'send it anyway',
  'strong dood fundamentals',
  'wen moon',
  'this feels right',
  'trust the dood',
  'not financial advice lol',
  'probably nothing',
  'LFG',
  'i saw a sign',
  'the chart said yes',
  'my gut says buy',
  'diamond hands activated',
  'this is the one',
  'source: trust me bro',
  'we are so early',
  'floor is lava',
  'devs are dooding',
];

function FloatingNote({ note, style, onClick }) {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div
      className="floating-note"
      style={style}
      onClick={() => {
        setVisible(false);
        if (onClick) onClick();
      }}
    >
      <svg
        viewBox="0 0 200 50"
        className="floating-note-bg"
        preserveAspectRatio="none"
      >
        <path
          d="M 3,5 Q 1,2 10,3 L 190,5 Q 198,4 197,12 L 195,40 Q 196,48 188,47 L 12,45 Q 4,46 5,38 Z"
          fill="#f5f3ee"
          stroke="#1a1a1a"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
      <span className="floating-note-text">{note}</span>
    </div>
  );
}

export default function FloatingNotes() {
  const [notes, setNotes] = useState([]);
  const [nextId, setNextId] = useState(0);

  const spawnNote = useCallback(() => {
    const note = NOTES[Math.floor(Math.random() * NOTES.length)];
    const id = nextId;
    const side = Math.random() > 0.5 ? 'right' : 'left';
    const top = 15 + Math.random() * 70;
    const xPos = side === 'left'
      ? 2 + Math.random() * 12
      : 78 + Math.random() * 12;
    const rotation = (Math.random() - 0.5) * 15;

    setNotes(prev => [
      ...prev.slice(-6), // keep max 7 notes
      {
        id,
        text: note,
        style: {
          position: 'fixed',
          top: `${top}vh`,
          left: `${xPos}vw`,
          transform: `rotate(${rotation}deg)`,
          zIndex: 1000,
        },
      },
    ]);
    setNextId(prev => prev + 1);
  }, [nextId]);

  useEffect(() => {
    // Spawn initial notes
    const timer1 = setTimeout(spawnNote, 2000);
    const timer2 = setTimeout(spawnNote, 5000);

    // Spawn periodically
    const interval = setInterval(spawnNote, 8000);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearInterval(interval);
    };
  }, [spawnNote]);

  const removeNote = (id) => {
    setNotes(prev => prev.filter(n => n.id !== id));
  };

  return (
    <div className="floating-notes-container">
      {notes.map(n => (
        <FloatingNote
          key={n.id}
          note={n.text}
          style={n.style}
          onClick={() => removeNote(n.id)}
        />
      ))}
    </div>
  );
}
